import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kurlatopunecab() {



const cardData = {
  keyword: " Kurla to Pune Taxi Service   ",

headingDescription: "Velocity Cab provides reliable and comfortable Kurla to Pune taxi services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Kurla to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Kurla to Pune taxi travel.",

topPlaces: [
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully maintained Japanese-style garden featuring serene landscapes, water streams, and lush greenery. Travelers booking a sedan cab in Pune can enjoy peaceful walks, photography, and a relaxing break from the city's busy environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular garden in Pune known for its scenic surroundings and the famous Siddhivinayak Temple located inside. It is a favorite spot for families, morning walkers, and visitors looking for a calm and refreshing atmosphere."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a historic site in Pune offering panoramic views of the city from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy breathtaking sunset views over Pune."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a significant monument in Indian history associated with Mahatma Gandhi and the freedom movement. It features elegant architecture, spacious gardens, and a museum showcasing important historical artifacts."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its unique architecture and peaceful spiritual environment."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum houses a vast collection of Indian antiques, musical instruments, sculptures, and cultural artifacts. It provides a rich insight into India’s traditional art and heritage."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification that was once the seat of the Peshwas. Visitors can explore its massive gates, ruins, and experience the light and sound show that narrates its glorious past."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most famous religious landmarks dedicated to Lord Ganesha. It attracts thousands of devotees daily and is especially vibrant during festivals."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a peaceful riverside park offering greenery, walking paths, and boating activities. It is a popular place for relaxation and evening strolls in Pune."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a leading shopping and entertainment destination featuring international brands, restaurants, cinemas, and entertainment zones for visitors of all ages."
  }
],



services: [
{
name: "Kurla to Pune Taxi Service Rates",
description: "Kurla to Pune taxi service rates provide transparent and affordable pricing for passengers traveling between Kurla in Mumbai and Pune city. Travelers can choose comfortable vehicles such as sedan, Ertiga, and Innova depending on travel requirements and budget. The journey via the Mumbai–Pune Expressway ensures smooth and fast intercity travel. Professional drivers provide punctual pickups from Kurla East, Kurla West, residential societies, offices, and hotels. This service is widely used for corporate travel, airport transfers, family trips, and tourist visits. Air-conditioned vehicles and spacious seating ensure a comfortable long-distance ride. Clear fare information helps passengers plan their travel budget easily while booking taxis online with instant confirmation."
},
{
name: "Kurla to Pune Taxi Service Number",
description: "Kurla to Pune taxi service number allows passengers to quickly connect with reliable cab providers for intercity travel. Travelers can easily book vehicles such as sedan, Ertiga, or Innova for comfortable journeys between Kurla and Pune. Professional drivers ensure safe driving and punctual pickups from homes, offices, and railway stations in Kurla. This service is ideal for corporate travelers, families, and airport passengers heading to Pune. Quick booking assistance, transparent pricing, and reliable customer support make travel convenient and stress-free."
},
{
name: "Kurla to Pune One Way Cab Service",
description: "Kurla to Pune one way cab service offers economical transportation for passengers traveling from Mumbai to Pune without paying for return fares. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel with experienced drivers. Pickup services are available from Kurla East, Kurla West, and nearby areas including Kurla railway station. This service is perfect for business trips, airport transfers, and personal visits to Pune. Air-conditioned vehicles and spacious seating ensure a relaxed journey. Online booking allows instant confirmation and transparent pricing for hassle-free travel."
},
{
name: "Kurla to Pimpri Cab Service",
description: "Kurla to Pimpri cab service provides dependable transportation between Kurla in Mumbai and the Pimpri area of Pune. Travelers can enjoy comfortable rides in well-maintained vehicles including sedan, Ertiga, and Innova. Professional drivers provide safe highway driving and punctual pickups from residential and commercial areas in Kurla. This service is widely used by corporate travelers visiting industrial zones and business hubs in Pimpri. Spacious vehicles and air-conditioned interiors ensure comfortable long-distance travel."
},
{
name: "Kurla to Pune Station Cab Fare",
description: "Kurla to Pune Station cab service offers reliable transportation between Kurla and Pune Railway Station. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel while professional drivers provide safe driving and punctual pickups. This service is ideal for passengers connecting to train journeys from Pune station. Transparent fare details help travelers plan their travel expenses easily while ensuring comfortable long-distance transportation."
},
{
name: "Kurla to Baner Cab Fare",
description: "Kurla to Baner cab service provides convenient intercity transportation between Kurla in Mumbai and Baner in Pune. Comfortable vehicles ensure smooth expressway travel while experienced drivers provide punctual pickup services from homes, offices, and hotels across Kurla. This taxi service is widely used by corporate travelers visiting IT companies and business hubs in Baner. Spacious vehicles and air-conditioned interiors ensure comfortable long-distance journeys."
},
{
name: "Kurla to Pune Ertiga Cab Fare",
description: "Kurla to Pune Ertiga cab service offers spacious 7-seater SUV transportation for families and small groups traveling between Mumbai and Pune. The Maruti Ertiga provides comfortable seating, air-conditioning, and smooth highway performance. Professional drivers ensure safe driving and timely pickups from Kurla. This service is ideal for airport transfers, family travel, and corporate trips."
},
{
name: "Kurla Station to Pune Taxi Service",
description: "Kurla Station to Pune taxi service provides reliable transportation for passengers traveling from Kurla railway station to Pune city. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel. Professional drivers provide timely pickups from the station and safe long-distance driving. This service is ideal for travelers arriving by train and continuing their journey to Pune."
},
{
name: "Kurla Station to Pune Sedan Taxi Service",
description: "Kurla Station to Pune sedan taxi service offers economical transportation using vehicles such as Swift Dzire, Etios, and Xcent. These cars are ideal for individuals and small families traveling between Mumbai and Pune. Professional drivers provide punctual pickups from Kurla station and safe highway travel via the expressway. Air-conditioned vehicles ensure comfortable long-distance journeys."
},
{
name: "Kurla to Viman Nagar Taxi",
description: "Kurla to Viman Nagar taxi service provides reliable transportation between Kurla in Mumbai and the Viman Nagar area of Pune. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and punctual pickups. This service is widely used by corporate travelers and airport passengers visiting Viman Nagar."
},
{
name: "Kurla to Pune Round Trip Cab",
description: "Kurla to Pune round trip cab service offers convenient transportation for passengers who need both onward and return travel. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova for smooth expressway travel. Professional drivers remain available for the entire trip including return journeys. This service is ideal for business meetings, family visits, and sightseeing trips."
},
{
name: "Taxi Service in Kurla Mumbai",
description: "Taxi service in Kurla Mumbai provides reliable transportation for city travel, airport transfers, and outstation journeys. Travelers can book comfortable vehicles with experienced drivers for safe travel across Mumbai and nearby destinations including Pune."
},
{
name: "Best Cab Service in Kurla Mumbai",
description: "Best cab service in Kurla Mumbai offers premium transportation with well-maintained vehicles and professional drivers. Travelers can enjoy comfortable rides for airport transfers, corporate travel, and long-distance trips to Pune and nearby cities."
},
{
name: "Innova Crysta on Rent in Kurla Mumbai",
description: "Innova Crysta on rent in Kurla Mumbai provides premium SUV transportation for passengers seeking luxury and comfort. Toyota Innova Crysta vehicles offer spacious seating, smooth suspension, and excellent highway performance for long-distance journeys to Pune and other destinations."
},
{
name: "Ertiga Hire in Kurla Mumbai",
description: "Ertiga hire in Kurla Mumbai offers spacious 7-seater SUV transportation for families and small groups. The Ertiga vehicle ensures comfortable seating and smooth highway travel for both city and outstation journeys."
},
{
name: "Kurla to Pune Cab",
description: "Kurla to Pune cab service offers dependable intercity transportation between Mumbai and Pune. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and punctual pickups."
},
{
name: "Kurla to Pune Taxi",
description: "Kurla to Pune taxi service provides convenient transportation between the two cities with comfortable vehicles and experienced drivers ensuring smooth highway journeys."
},
{
name: "Kurla to Pune Taxi Service",
description: "Kurla to Pune taxi service offers reliable long-distance transportation with professional drivers and comfortable vehicles ensuring safe travel."
},
{
name: "Kurla to Pune Cab Service",
description: "Kurla to Pune cab service provides dependable intercity travel with smooth expressway transportation, professional drivers, and comfortable vehicles."
},
{
name: "Kurla to Pune One Way Cab",
description: "Kurla to Pune one way cab service offers economical transportation for passengers needing a single-direction trip between the two cities."
},
{
name: "Kurla to Pune Taxi Booking",
description: "Kurla to Pune taxi booking allows passengers to easily reserve taxis through online platforms with instant confirmation and transparent fares."
},
{
name: "Kurla to Pune Drop Taxi",
description: "Kurla to Pune drop taxi service offers convenient one-way transportation with affordable fares and comfortable vehicles."
},
{
name: "Kurla to Pune Online Cab Booking",
description: "Kurla to Pune online cab booking allows passengers to reserve taxis instantly through websites or mobile platforms for convenient travel."
},
{
name: "Kurla to Pune Private Cab",
description: "Kurla to Pune private cab service provides exclusive transportation for passengers seeking privacy and flexible pickup timing."
},
{
name: "Kurla to Pune Outstation Cab",
description: "Kurla to Pune outstation cab service provides dependable long-distance travel with experienced drivers and comfortable vehicles."
},
{
name: "Kurla to Pune Cheap Cab",
description: "Kurla to Pune cheap cab service offers budget-friendly transportation for travelers seeking economical intercity travel options."
}
],

tableData: [
["Kurla to Pune Taxi Service Rates","Kurla to Pune Taxi Service Number"],
["Kurla to Pune One Way Cab Service","Kurla to Pimpri Cab Service"],
["Kurla to Pune Station Cab Fare","Kurla to Baner Cab Fare"],
["Kurla to Pune Ertiga Cab Fare","Kurla Station to Pune Taxi Service"],
["Kurla Station to Pune Sedan Taxi Service","Kurla to Viman Nagar Taxi"],
["Kurla to Pune Round Trip Cab","Taxi Service in Kurla Mumbai"],
["Best Cab Service in Kurla Mumbai","Innova Crysta on Rent in Kurla Mumbai"],
["Ertiga Hire in Kurla Mumbai","Kurla to Pune Cab"],
["Kurla to Pune Taxi","Kurla to Pune Taxi Service"],
["Kurla to Pune Cab Service","Kurla to Pune One Way Cab"],
["Kurla to Pune Taxi Booking","Kurla to Pune Drop Taxi"],
["Kurla to Pune Online Cab Booking","Kurla to Pune Private Cab"],
["Kurla to Pune Outstation Cab","Kurla to Pune Cheap Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Kurla to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Taxi Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Kurla to Pune taxi service bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Availability",
    WhyChoosedescription: "Our Kurla to Pune taxi service operates 24 hours a day. Whether you need an early morning ride, airport transfer, business travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way taxi service, round-trip bookings, airport transfers, and customized travel plans from Kurla to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Kurla",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Kurla including Kurla East, Kurla West, and nearby locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Taxi Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Kurla to Pune taxi service bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Kurla to Pune taxi service?", answer: "Yes, Velocity Cabs provides reliable taxi services from Kurla to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Kurla from Pune?", answer: "The road distance between Kurla and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Kurla to Pune taxi service available 24 hours?", answer: "Yes, our taxi service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Kurla to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way taxi from Kurla to Pune?", answer: "Yes, we provide both one-way and round-trip taxi services between Kurla and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Kurla." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the taxi online?", answer: "Yes, customers can easily book Kurla to Pune taxi services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Faisal Shaikh",
    feedback:
      "The Kurla to Pune journey was very comfortable and well-managed. The cab arrived on time, the ride quality was smooth, and the overall travel experience felt stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Nisha Kulkarni",
    feedback:
      "From Kurla to Pune, the travel experience was really good. The vehicle was clean, the drive was steady, and everything was handled in a very professional way.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kurla to Pune Taxi Service | Velocity Cabs",
  "description": "Velocity Cabs provides professional Kurla to Pune taxi service with comfortable and affordable rides. Choose from Innova, Innova Crysta, Ertiga, and Sedan cabs for one way, round trip, or airport transfers. Safe, reliable, and convenient taxi service from Kurla to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      <Helmet>
  <title>Kurla to Pune Taxi | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Kurla to Pune taxi with Velocity Cabs. Affordable one way & round trip cabs including Innova, Innova Crysta, Ertiga & Sedan for airport transfers, city travel & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kurlatopunecab;